import React, {useEffect} from 'react'
import '../GeneracionFactura/styles/SETable.css'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionSujetoExcluidoProducto} from '../../../../actions/action-creators'
import TablaFacturacionSE from '../GeneracionFactura/TablaFacturacionSE'

const SETablaResumen = () => {
  const arrayProductos = useSelector((state: State) => state.sujetoExcluido.arrayProductos)
  const calculos = useSelector((state: State) => state.sujetoExcluido.calculosArrayProductos)
  const idDoc = useSelector((state: State) => state.documentos.activeDoc?.idDoc)
  const dispatch = useDispatch()
  const {sujetoExcluidoCalculoTotalArrayProducto} = bindActionCreators(actionSujetoExcluidoProducto, dispatch)

  useEffect(() => {
    sujetoExcluidoCalculoTotalArrayProducto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrayProductos])

  return (
    <div className='w-layout-vflex card-content'>
      <TablaFacturacionSE datos={calculos} arrayProductos={arrayProductos} rows={arrayProductos} sinAcciones={true} idDoc={idDoc}/>
    </div>
  )
}

export default SETablaResumen
